/**
 * External dependencies
 */
import {
	ImageUploadPlaceholder, IconDisplay
} from '~cartzillagb/components'
import {
	withUniqueClass,
} from '~cartzillagb/higher-order'
import classnames from 'classnames'
import { range } from '~cartzillagb/util'
import { i18n } from 'cartzillagb'

/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n'
import { RichText } from '@wordpress/block-editor'
import { applyFilters } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'


const save = props => {
	const {
		className, attributes,
	} = props

	const {
		enableContainer,
		displayTitle,
		displayDesc,
		displayList,
		displayImage,
		title,
		subtitle,
		limit,
        customiconcolor,
		iconcolor,
		mediaURL,
		enableIcon
	} = attributes

	const mainClasses = classnames( [
		className,
		'bg-dark py-5',
		'info-section-1-block'
	], applyFilters( 'cartzillagb.info-section-1.main-block.classes', {}, props ) )

	const containerClasses = classnames( [
		' py-3 py-lg-4',
		enableContainer ? 'container' : '',
	] )

		

	return (
		<section className={ mainClasses }>
			<div className={ containerClasses }>
				<div className="row align-items-center">
					<div className="col-xl-4 col-lg-5 pb-4 pb-lg-0">
						{ displayTitle && 
							<RichText.Content
								tagName='h2'
								className="text-light"
								value={ title || '<span class="font-weight-light">Complete</span> E-Commerce Front-End <span class="font-weight-light">Solution</span>' }
							/>
						}

						{ displayDesc && 
							<RichText.Content
								tagName='p'
								className="text-light opacity-70"
								value={ subtitle || 'All you need for your next e-commerce project' }
							/>
						}

						{ displayList && 
							<ul className={ `text-light list-unstyled pt-3 ` }>
			                    { range(1, limit + 1).map(i => {
			                        const Icon = attributes[ `icon${ i }` ]
									const listitems = attributes[ `listitems${ i }` ]

									let defaultListItems =''
									const defaultIcon = 'czi-check-circle'

									if ( (i % 10 ) === 1 ) {               
										defaultListItems = (__('Shop Grid / List Layout Options', i18n )) 
									}
									if ( (i % 10 ) === 2 ) {               
										defaultListItems = (__('Multiple Product Page Variations', i18n ))
									}
									if ( (i % 10 ) === 3 ) {               
										defaultListItems = (__('Complete Order Workflow: Cart + Checkout', i18n ))
									}
									if ( (i % 10 ) === 4 ) {               
										defaultListItems = (__('Shop Customer Account Pages', i18n ))
									}
									if ( (i % 10 ) === 5 ) {               
										defaultListItems = (__('Vendor Dashboard for Multi-vendor Marketplaces', i18n ))
									}
									if ( (i % 10 ) === 6 ) {               
										defaultListItems = (__('Ready for any Content: Fashion, Electronics, Digital (Downloadable) Products, etc.', i18n ))
									}
									if ( (i % 10 ) === 7 ) {               
										defaultListItems = (__('Blog Pages: Blog Layouts + Single Post', i18n ))
									}
									if ( (i % 10 ) === 8 ) {               
										defaultListItems = (__('Help Center / Support Pages', i18n ))
									}
									if ( (i % 10 ) === 9 ) {               
										defaultListItems = (__('Secondary Pages: About, Contacts, 404, etc.', i18n ))
									}
									if ( (i % 10 ) === 0 ) {               
										defaultListItems = (__('B40+ Flexible Components', i18n ))
									}
									const iconComp = (
										<IconDisplay 
											value={ Icon || defaultIcon }
											additionalClass={ `mr-2 ${ iconcolor ? iconcolor : customiconcolor ? '' : 'text-success' }` }
										/>    
									)

									const listItemComp = (
										<RichText.Content
											tagName="span"
											value={ listitems || defaultListItems }
										/>
									)

									return ( 
										
							            <li className="d-flex align-items-center" key={ i }>
							            	{ enableIcon && iconComp } { listItemComp }
							            </li>
							            
							        ) 
								} ) }
			                </ul>
						}
					</div>
					{ displayImage && 
						<div className="col-lg-7 offset-xl-1">
							<ImageUploadPlaceholder
								imageURL={ mediaURL }
								render={ <img src={ mediaURL } alt={ __( 'Cartzilla pages' ) } /> }
							/>
						</div>
					}
				</div>
			</div>
		</section>
	)  
}


export default compose(
	withUniqueClass,
)( save )